/**
 *
 * FBDocumentsPreview
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
//import { Button } from 'antd';

// Communication components
import {
  FBSectionHeader,
  FBPreviewFile,
} from 'components/Communications';

// icons
import CustomIcons from 'components/CustomIcons';


function FBDocumentsPreview({
  documents,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-documents-group-preview', 'tcf-fb-group-preview', className);
  
  return !!documents && (
    <div {...rest} className={childClassNames}>
      <FBSectionHeader type="documents" />
      <div className='tcf-fb-group-preview__content'>
        {documents['documents-fields']?.map((doc, docIndx) => {
          return !!doc && (
            <FBPreviewFile
              key={`FBPreviewFile-${docIndx}`}
              showTitle={false}
              file={doc[`file-url`]}
              fileTitle={doc[`file-name`]}
              showIcon={true}
              showIconPreview={true}
              iconPreview={<CustomIcons className="icon-preview" type="arrow-right" />}
            />
          );
        })}
      </div>
      
    </div>
  );
}

FBDocumentsPreview.defaultProps = {
  type: 'documents',
};
FBDocumentsPreview.propTypes = {
  documents: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

export default memo(FBDocumentsPreview);
